

















import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import Languages from './index';

const name = 'ttam-languages-compose-flex';
export default defineComponent({
  name,
  components: {
    TtamLanguages: Languages.TtamLanguages,
  },
  props: {
    languageState: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    languageOptions: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { languageState } = toRefs(props);
    const _languageList = computed({
      get: () => (languageState.value[0] === 'ALL' || languageState.value[0] === 'NO_LIMIT' ? [] : languageState.value),
      set: val => {
        emit('change', val);
      },
    });

    return {
      name,
      _languageList,
    };
  },
});
